const LOCALE = "sv";

export const formatDateTime = (value?: string | number | Date) => {
  if (!value) return "";

  return new Date(value).toLocaleString(LOCALE);
};

export const formatDate = (value?: string | number | Date) => {
  if (!value) return "";

  return new Date(value).toLocaleDateString(LOCALE);
};

export const formatTime = (value?: string | number | Date) => {
  if (!value) return "";

  return new Date(value).toLocaleTimeString(LOCALE);
};
